import React from "react";
import { AdminSearchProvider } from "./store/adminSearchStore";
import AdminUserSearchPage from "./AdminSearchPage";

export default function AdminSearchPageWrapper() {
  return (
    <AdminSearchProvider>
      <AdminUserSearchPage />
    </AdminSearchProvider>
  );
}

